export const RenderLegalTerms = (key: string, src: string) => <div key={key} className="TZALegalTerms" dangerouslySetInnerHTML={{ __html: src }} />;